import { render, staticRenderFns } from "./PeopleIndex.vue?vue&type=template&id=6c3157d4"
import script from "./PeopleIndex.vue?vue&type=script&lang=js"
export * from "./PeopleIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports